import { cellRenderParseData } from '../../../utils/functions';
import { cellRenderPopupAct } from '../../PopupActMVP/functionPopupAct';

/** Список полей */
const columnDataGrid = [
  {
    dataField: 'docNumId',
    dataType: 'number',
    caption: 'ID акта'
  },
  {
    dataField: 'docId',
    dataType: 'string',
    caption: 'Номер акта',
    cellRender: cellRenderPopupAct
  },
  {
    dataField: 'docType',
    dataType: 'string',
    caption: 'Тип акта (описание)'
  },
  {
    dataField: 'docDate',
    dataType: 'date',
    caption: 'Дата акта',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'stockDescr',
    caption: 'Склад',
    dataType: 'string'
  },
  {
    dataField: 'creationUser',
    dataType: 'string',
    caption: 'ФИО создателя'
  },
  {
    dataField: 'docStatusDesc',
    dataType: 'string',
    caption: 'Статус акта (описание)'
  },
  {
    dataField: 'inSign',
    dataType: 'string',
    caption: 'Подпись внутренняя'
  },
  {
    dataField: 'inSignDatetime',
    dataType: 'string',
    caption: 'Дата внутренней подписи'
  },
  {
    dataField: 'extSign',
    dataType: 'string',
    caption: 'Подпись внешняя'
  },
  {
    dataField: 'extSignDatetime',
    dataType: 'string',
    caption: 'Дата внешней подписи'
  },
  {
    dataField: 'modDatetime',
    dataType: 'string',
    caption: 'Время изменения'
  },
  {
    dataField: 'modUser',
    dataType: 'string',
    caption: 'ФИО изменившего'
  },
  {
    dataField: 'eventId',
    dataType: 'number',
    caption: 'ID сообщения'
  },
  {
    dataField: 'eventStatus',
    dataType: 'number',
    caption: 'Статус сообщения'
  },
  {
    dataField: 'guid',
    dataType: 'string',
    caption: 'GUID'
  },
  {
    dataField: 'extGuid',
    dataType: 'string',
    caption: 'GUID сторонней системы'
  },
  {
    dataField: 'docTypeNumId',
    dataType: 'number',
    notVisible: true,
    caption: 'Тип акта (id)'
  },
  {
    dataField: 'docStatus',
    dataType: 'number',
    notVisible: true,
    caption: 'Статус акта (id)'
  }
];

export default columnDataGrid;
